import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { FeatureFlagUI, FlagFormPayload } from 'src/app/domains/feature-flags/models/feature-flags.model';
import { FeatureFlagsService } from 'src/app/domains/feature-flags/services';
import { FeatureFlag, FeatureFlagRequest } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-add-edit-flag-modal',
  templateUrl: './add-edit-flag-modal.component.html',
  styleUrls: ['./add-edit-flag-modal.component.scss']
})
export class AddEditFlagModalComponent {
  private readonly activeModal: NgbActiveModal = inject(NgbActiveModal);
  private readonly featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);
  @Output() onFlagSubmit: EventEmitter<void> = new EventEmitter<void>();

  @Input() title: string = '';
  @Input() flag: FeatureFlagUI;
  @Input() flags: FeatureFlag[] = [];

  public loading: boolean = false;

  public onSubmit(e: FlagFormPayload) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    const payload: FeatureFlagRequest = {
      ...e,
      enabled_company_ids: this.flag.enabled_company_ids || [],
      rollout_percentage: this.flag.rollout_percentage || 0
    }

    const request$ = this.flag.isEditing 
      ? this.featureFlagService.updateFeatureFlag(this.flag.id, payload) 
      : this.featureFlagService.createFeatureFlag(payload);

    request$.pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: () => {
        this.onFlagSubmit.emit();
        this.close();
      },
      error: () => {}
    })
    
  }

  public close(): void {
    this.activeModal.close();
  }
}
